import { FormFormattedField, FormInput } from 'components';
import { StyledField, StyledGrid, StyledLabel } from '../ui';
import { normalizeFormattedField } from 'utils';
import { composeValidators, required, validateMinBid, validateMinOffer } from 'utils/validators';
import { useForm } from 'react-final-form';
import { useIsAlternativeAuction } from 'hooks';
import { Vehicle } from 'types/vehicle';
import { AUCTION_TYPES } from 'constants';
import { useStartingBidValidator } from 'hooks/useGetValidators';

export const StartingBidField = () => {
  const form = useForm();
  const { values } = form.getState();

  const auctionType = values.auction?.type || AUCTION_TYPES.AUTOAXESS;
  const validateStartingBid = useStartingBidValidator(auctionType);

  return (
    <StyledGrid item xs={12}>
      <StyledLabel>Starting/Min bid</StyledLabel>
      <StyledField
        name="starting_bid"
        component={FormFormattedField}
        placeholder="100$"
        // @ts-ignore
        thousandSeparator
        allowNegative={false}
        fixedDecimalScale
        prefix="$"
        customInput={FormInput}
        parse={normalizeFormattedField}
        disableUnderline
        validate={composeValidators(...validateStartingBid)}
      />
    </StyledGrid>
  );
};
